export enum AssessmentStatus {
  Pending = 'PENDING',
  Passed = 'PASSED',
  Failed = 'FAILED',
}
